/**
 * AddFeaturedRowItemsCtrl controller
 */
// preload drag'n'drop image
const dragndropImg = new window.Image()
dragndropImg.src = require('../../img/dragndrop.png')

/* @ngInject */

export default function EditShelvesCtrl (
  $uibModal,
  Shelf,
  pckg,
  scope,
  subscriptions
) {
  const vm = this
  vm.subscriptions = subscriptions
  vm.pckg = pckg

  vm.scope = scope

  scope.updatedShelves = false

  vm.shelvesValidation = []

  vm.contentShelfTypes = {
    CHANNEL: { label: 'Channels', label2: 'Channel', tabHeader: 'Channel', setType: 'channelsets' },
    VOD: { label: 'Movies', label2: 'Movie', tabHeader: 'Movie', setType: 'vodsets' },
    TV_SHOW: { label: 'TV Shows', label2: 'TV Show', tabHeader: 'TV Show', setType: 'tv-show-sets' },
    LIVE_EVENT: { label: 'Live Events', label2: 'Live Event', tabHeader: 'Live Event', setType: 'live-event-sets' }
    // MIXED: {}
  }

  vm.shelves = {}

  scope.shelves = vm.shelves

  Object.keys(vm.contentShelfTypes).forEach((key) => { vm.shelves[key] = [] })

  /**
   * Default values for table state
   *
   * @type {Object}
   */
  const defaultFFTableState = {
    page: 0,
    count: 5,
    contentType: ''
  }

  vm.loadShelves = function (contentType, resetState = false) {
    if (resetState) {
      vm.contentShelfTypes[contentType].shelvesState = angular.copy({ ...defaultFFTableState, contentType })
    } else {
      vm.contentShelfTypes[contentType].shelvesState.page++
    }

    Shelf.loadAll({ networkId: vm.pckg.id, params: vm.contentShelfTypes[contentType].shelvesState }).then((result) => {
      vm.contentShelfTypes[contentType].shelvesState.page = result.number
      vm.contentShelfTypes[contentType].shelvesState.last = result.last
      for (const shelf of result.content) {
        vm.shelves[shelf.contentType].push(new Shelf({ ...shelf, networkId: vm.pckg.id }))
      }
    })
  }

  for (const contentType in vm.contentShelfTypes) {
    vm.loadShelves(contentType, true)
  }

  vm.addContentShelf = function (contentType) {
    const newShelf = new Shelf({ contentType, networkId: vm.pckg.id, sortingRuleName: 'MIXED_MANUAL_ASC', $action: 'create', $is_open: true })
    vm.shelves[contentType].unshift(newShelf)
  }

  vm.validateShelvesType = function (contentTypeKey) {
    return !vm.shelvesValidation.filter(i => i.shelf.contentType === contentTypeKey).every(i => { return i.valid })
  }
  vm.addFromCategory = function (contentType) {
    $uibModal.open({
      templateUrl: 'components/packages/components/shelves/addFromCategory.html',
      controller: 'AddFromCategoryCtrl as vm',
      animation: false,
      size: 'md',
      resolve: {
        contentType: function () { return contentType },
        pckgId: function () { return pckg.id }
      }
    })
      .result
      .then(
        function close (category) {
          Shelf._getShelfFromCategory(pckg.id, category.id, { contentType })
            .then(shelf => {
              vm.shelves[shelf.contentType].unshift(new Shelf({ ...shelf, networkId: pckg.id, $action: 'create', $is_open: true, $fromCategory: true }))
            })
        },
        function dismiss () { }
      )
  }
}
